<div style="height:calc(100vh - 235px);">
    <dx-data-grid #logsGrid
                  height="100%"
                  hoverStateEnabled="true"
                  [columnAutoWidth]="true"
                  [dataSource]="dataSource"
                  [errorRowEnabled]="false"
                  [focusedRowEnabled]="true"
                  [wordWrapEnabled]="false"
                  (onRowDblClick)="onRowDblClick($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"/>
        <dxo-header-filter [visible]="true"/>
        <dxo-paging [enabled]="false"/>
        <dxo-scrolling showScrollbar="always"/>
        <dxo-summary>
            <dxi-total-item column="transferDate" [displayFormat]="'logs.lblLogsCount' | translate" summaryType="count"/>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="onRefreshButtonClick()" />
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-date-range-box applyValueMode="useButtons" 
                                       displayFormat="MMMM d, yyyy"
                                       labelMode="hidden" 
                                       width="320" 
                                       [max]="maxDate" 
                                       [(value)]="selectedDates" 
                                       (onValueChanged)="onDatesChanged()"/>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel" />
        </dxo-toolbar>

        <dxi-column dataField="transferDate"
                    dataType="datetime"
                    format="MMMM d, yyyy HH:mm:ss"
                    [caption]="'logs.lblDateUtc' | translate"/>
        <dxi-column dataField="logTypeEnums" 
                    [calculateCellValue]="displayFileTransferLogType"
                    [caption]="'logs.lblType' | translate" />
        <dxi-column dataField="localAgent.name" 
                    [caption]="'logs.lblLocalAgentName' | translate"/>
        <dxi-column dataField="sourceFileName" 
                    [caption]="'logs.lblSourceFileName' | translate"/>
        <dxi-column dataField="sourceFileSize"  
                    [alignment]="'right'"
                    [calculateCellValue]="formatSourceFileSize"
                    [caption]="'logs.lblSourceFileSizeKb' | translate" />
        <dxi-column dataField="targetFileName" 
                    [caption]="'logs.lblTargetFileName' | translate"/>
        <dxi-column dataField="targetFileSize" 
                    [alignment]="'right'" 
                    [calculateCellValue]="formatTargetFileSize" 
                    [caption]="'logs.lblTargetFileSizeKb' | translate"/>
        <dxi-column dataField="archivedFileName" 
                    [caption]="'logs.lblArchivedFileName' | translate"/>
        <dxi-column dataField="archivedFileSize" 
                    [alignment]="'right'"
                    [calculateCellValue]="formatArchivedFileSize" 
                    [caption]="'logs.lblArchivedFileSizeKb' | translate" />
    </dx-data-grid>
</div>

<app-file-transfer-log #logDetailsPopup [log]="selectedLog"/>